import { useEffect, useState } from "react";

/**
 * Ritarda la propagazione di un valore. Serve quando il valore pilota una
 * chiamata server: senza attesa ne partirebbe una per ogni tasto premuto o per
 * ogni casella spuntata.
 *
 * Il ritardo va scelto in base al gesto, non in astratto: 300 ms circa per i
 * toggle (dove due click consecutivi distano già più di così), 600-800 ms per
 * gli input di testo o numerici. Ritardi molto più lunghi non "risparmiano
 * chiamate": rendono solo l'interfaccia lenta a rispondere.
 *
 * Viveva in usePaymentsDashboard, che lo ri-esporta per compatibilità.
 */
export const useDebouncedValue = <T,>(value: T, delayMs = 350): T => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), delayMs);
        return () => window.clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
};
